module.exports = __webpack_public_path__ + "static/media/icon-public-opp.5c394cba.svg";